import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { addToken, signIn, signOut } from "../store/slices/auth";
import { useNavigate } from "react-router-dom";

export default function useAuth() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { user } = useSelector((state: RootState) => state.auth);

  const logIn = useCallback(
    function (user: User, token?: string) {
      if (token) {
        dispatch(addToken(token));
        localStorage.setItem("admin-token-v1", token);
      }
      if (user) dispatch(signIn(user));
    },
    [dispatch]
  );

  const logOut = useCallback(() => {
    dispatch(signOut());
    localStorage.clear();
    navigate('/login')
  }, [dispatch]);

  const updateToken = useCallback(
    (token: string) => {
      dispatch(addToken(token));
    },
    [dispatch]
  );

  const checkUserPermission = (right: string) => {
    return user?.permissions?.includes(right);
  }

  return {
    user,
    logIn,
    logOut,
    updateToken,
    checkUserPermission,
  };
}